import { Controller } from "@hotwired/stimulus"

// Handles file input label updates and translations
export default class extends Controller {
  static targets = ["input", "label", "button"]
  static values = {
    noFileChosenText: String,
    chooseFileText: String
  }

  connect() {
    this.updateLabel()
  }

  triggerInput(event) {
    event.preventDefault()
    event.stopPropagation()
    this.inputTarget.click()
  }

  updateLabel() {
    const input = this.inputTarget
    const label = this.labelTarget
    const button = this.buttonTarget
    
    if (input.files && input.files.length > 0) {
      // File selected - show filename in label, update button text
      const fileName = input.files[0].name
      label.textContent = fileName
      label.classList.remove('text-muted', 'd-none')
      label.classList.add('text-success', 'fw-medium')
      
      // Update button to show "change file" or keep original text
      const buttonText = button.querySelector('span, .fa-upload').nextSibling
      if (buttonText && buttonText.nodeType === Node.TEXT_NODE) {
        buttonText.textContent = ` ${this.chooseFileTextValue || 'בחר קובץ'}`
      }
    } else {
      // No file selected - show default message
      label.textContent = this.noFileChosenTextValue || 'לא נבחר קובץ'
      label.classList.remove('text-success', 'fw-medium', 'd-none')
      label.classList.add('text-muted')
    }
  }
}

